module.exports = __webpack_public_path__ + "img/B5.62bb4b0b.png";